import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

/**
 * Reusable Empty State Component
 */
const EmptyState = ({
  icon = '📦',
  title,
  message,
  actionLabel,
  onAction,
  hasItems = false
}) => {
  const { t } = useLanguage();
  return (
    <div className='card text-center py-12'>
      <div className='text-6xl mb-4'>{icon}</div>
      <p className='text-xl font-semibold text-gray-900 mb-2'>
        {hasItems ? t('common.noResults') : title}
      </p>
      <p className='text-gray-500 mb-6'>
        {hasItems
          ? t('emptyState.tryAdjusting')
          : message}
      </p>
      {!hasItems && actionLabel && onAction && (
        <button onClick={onAction} className='btn-primary'>
          {actionLabel}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
